export const MFA_IDS_CONSTANTS = {
    EMAIL_MFA_ID: 'email_mfa',
    AUTHENTICATOR_MFA_ID: 'authenticator_mfa',
    DUO_MFA_ID: 'duo_mfa',
};

export const USER_STATUS_CONSTANTS = {
    ACTIVE: 'active',
    PENDING: 'pending',
    EXPIRED: 'expired',
    DISABLED: 'disabled',
};

export const FILTER_IDS = {
    ROLES_ID: 'rolesFilter',
    STATUS_ID: 'statusFilter',
    AUTH_ID: 'authenticationFilter',
    MFA_ID: 'mfaFilter',
    CONNECTED_APPS_ID: 'connectedAppsFilter',
};
